export const getOperationCollaboratorsInitialState = {
	collaborators: null,
	error: null,
	errorShow: false,
	loading: false,
};
